import { Component } from '@angular/core';

@Component({
  selector: 'app-page-como-incubar-sua-empresa',
  templateUrl: './page-como-incubar-sua-empresa.component.html',
  styleUrls: ['./page-como-incubar-sua-empresa.component.scss']
})
export class PageComoIncubarSuaEmpresaComponent {

}
